import { AccountTriageState } from '@interfaces/state';
import { AccountTypes, IndividualDesignationListedTypes } from '@shared/models';

export const TAX_DOCUMENTATION_REQUIRED_STATES = {
  NJ: 'NJ',
  PA: 'PA',
} as const;

export function isPAEligibleForTaxDocumentation(
  accountTypeInheriting: string,
  individualDesignation: string,
  isSpouse: string,
): boolean {
  return (
    (accountTypeInheriting === AccountTypes.INDV || accountTypeInheriting === AccountTypes.JOINT) &&
    individualDesignation === IndividualDesignationListedTypes.BENEFICIARY &&
    isSpouse === 'NO'
  );
}

export function isTaxDocumentationRequired(
  inheritanceWaiverState: string,
  fromAccount: AccountTriageState,
): boolean {
  return (
    inheritanceWaiverState === TAX_DOCUMENTATION_REQUIRED_STATES.NJ ||
    (inheritanceWaiverState === TAX_DOCUMENTATION_REQUIRED_STATES.PA &&
      isPAEligibleForTaxDocumentation(
        fromAccount.accountTypeInheriting,
        fromAccount.individualDesignation,
        fromAccount.isSpouse,
      ))
  );
}
